module.exports = __webpack_public_path__ + "static/gtp-hardcover-final-ea86c37e4955bc55611c3b500296930d.png";